import {Component, Input} from "@angular/core";
import {FormGroup} from "@angular/forms";

@Component({
  selector: 'app-date-select',
  templateUrl: './date-select.component.html',
  styleUrls: ['./date-select.component.scss']
})

export class DateSelectComponent {
  @Input() formGroupParent: FormGroup;
  @Input() formName: string;
  @Input() labelName: string;
  @Input() selectedVal: string;
  @Input() mandatory: boolean;
  @Input() disabledBol: boolean;
  @Input() classCustom: string;
  @Input() classIcon: string;

  constructor() {

  }

  // helpers for View
  isControlValid(controlName: string): boolean {
    const control = this.formGroupParent.controls[controlName];
    return control.valid && (control.dirty || control.touched);
  }

  isControlInvalid(controlName: string): boolean {
    const control = this.formGroupParent.controls[controlName];
    return control.invalid && (control.dirty || control.touched);
  }

  controlHasError(validation, controlName): boolean {
    const control = this.formGroupParent.controls[controlName];
    return control.hasError(validation) && (control.dirty || control.touched);
  }

  isControlTouched(controlName): boolean {
    const control = this.formGroupParent.controls[controlName];
    return control.dirty || control.touched;
  }
}
